module.exports = __webpack_public_path__ + "img/downloadPage_banner.8150b86c.png";